<template>
  <div class="animated fadeIn">
      <div class="page-header d-flex">
        <h4 class="page-title">
          <i class="fas fa-list-alt"></i>
          WMDS Dashboard
        </h4>
        <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
            <a href="#">
              <i class="fas fa-home text-muted"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a class="font_15 font-weight-bold" href="#">Dashboard</a>
          </li>
        </ul>
      </div>
      <div class="alert">
        <div class="row mb-3">
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
            <strong>Last System Pattern</strong>
          </div>
          <div class="col-xl-4 col-md-12 d-flex align-self-center">
            <span v-if="pattern" >{{ pattern.created_at | datetime}}</span>
            <span v-else >-</span>
          </div>
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
            <strong v-if="pattern" >{{ codes.WMDS_TYPE[pattern.type || ''] }}</strong>
          </div>
          <div class="col-xl-4 col-md-12 d-flex align-self-center">
            <span v-if="pattern" >{{ pattern.code | truncate(50) }}</span>
            <span v-else >-</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 mb-2">
          <hr>
          <!--//-------------------------------------------------------------------------검색조건-->
          <div class="d-flex flex-wrap align-items-center">
            <div class="mr-auto mb7">
              <label class="col-form-label font_20">
                Detect
              </label>
            </div>
            <div class="mb7">
              <button class="btn btn-sm btn-primary" @click="pause('detect')">
                <i :class="`fa fa-refresh ${detect.th && !detect.stop ? 'fa-spin' : ''}`"></i>
                Pause
              </button>
            </div>
          </div>
          <div class="d-flex flex-wrap align-items-center mb10">
            <div class="mr-auto mb7 form-inline" v-b-tooltip.hover title="can see the log real-time">
              <label class="col-form-label mr-2" for="sel3">Real-time</label>
              <select class="form-control mr-2" name="sel3" id="sel3" v-model="detect.interval" @change="refresh('detect')">
                <option disabled value="15">Please select interval : Default 15</option>
                <option value=10>10</option>
                <option value=30>30</option>
                <option value=60>60</option>
                <option value=300>300(5 min)</option>
              </select>
              <label class="col-form-label mr-2" for="sel3">sec</label>
            </div>
            <div class="mb7">
              <select class="form-control" name="sel2" id="sel2" v-model="model.detect.so.limit" @change="refresh('detect')">
                <option disabled value="15">Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </div>
          </div>
          <!--//-------------------------------------------------------------------------검색조건-->
          <!--//-------------------------------------------------------------------------리스트출력-->
          <div class="reg_card">
            <div class="reg_card_body">
              <div class="table-responsive">
                <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list_detect"
                  show-empty empty-text="There is no history of Detect!" :tbody-tr-class="rowHighlight"
                  :items="getDetect" :fields="f_detect" :current-page="so.currentPage" :per-page="model.result.so.limit" :sortBy="so.sk" @row-clicked="detail" style="cursor:pointer;">
                  <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
                  <template slot="domain" slot-scope="row">{{row.item.domain }}</template>
                  <template slot="type" slot-scope="row">
                    {{codes.WMDS_TYPE[row.item.type]}}
                  </template>
                  <template slot="func" slot-scope="row">
                    <b-btn @click="$router.push(`detect/${row.item.id}`)" size="sm" class="btn btn-sm btn-insert" tabindex="4">More</b-btn>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <!--//-------------------------------------------------------------------------리스트출력-->
          <!--//-------------------------------------------------------------------------List 버튼 -->
          <div class="mt30 d-flex flex-wrap align-items-center">
            <div class="ml-auto">
              <button class="btn btn-addition mr-1" @click="$router.push(`detect`)">
                List
              </button>
            </div>
          </div>
          <!--//-------------------------------------------------------------------------List 버튼 -->
        </div>
        <div class="col-xl-6 mb-2">
        <hr>
        <!--//-------------------------------------------------------------------------검색조건-->
        <div class="d-flex flex-wrap align-items-center">
          <div class="mr-auto mb7">
            <label class="col-form-label font_20">
              Result
            </label>
          </div>
          <div class="mb7">
            <button class="btn btn-sm btn-primary" @click="pause('result')">
              <i :class="`fa fa-refresh ${result.th && !result.stop ? 'fa-spin' : ''}`"></i>
              Pause
            </button>
          </div>
        </div>
        <div class="d-flex flex-wrap align-items-center mb10">
          <div class="mr-auto mb7 form-inline" v-b-tooltip.hover title="can see the log real-time">
            <label class="col-form-label mr-2" for="sel3">Real-time</label>
            <select class="form-control mr-2" name="sel3" id="sel3"  v-model="result.interval" @change="refresh('result')">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <label class="col-form-label mr-2" for="sel3">sec</label>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="model.result.so.limit" @change="refresh('result')">
              <option disabled value="15">Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </div>
        <!--//-------------------------------------------------------------------------검색조건-->
        <!--//-------------------------------------------------------------------------리스트출력-->
        <div class="reg_card">
          <div class="reg_card_body">
            <div class="table-responsive">
              <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list_result"
                  show-empty empty-text="There is no history of Result!" :tbody-tr-class="rowHighlight"
                  :items="getResult" :fields="f_result" :current-page="so.currentPage" :per-page="model.result.so.limit" :sortBy="so.sk">
                <template slot="finished_at" slot-scope="row">{{ row.item.finished_at | datetime}}</template>
                <template slot="fqdn" slot-scope="row">{{row.item.site.fqdn}}</template>
                <template slot="count" slot-scope="row">
                  {{row.item.page_count|number}} / {{row.item.ext_count|number}} / {{row.item.detect_count|number}} / {{row.item.binary_coount|number}} / {{row.item.error_count|number}}
                </template>
              </b-table>               
            </div>
          </div>
        </div>
        <!--//-------------------------------------------------------------------------리스트출력-->
        <!--//-------------------------------------------------------------------------List 버튼 -->
        <div class="mt30 d-flex flex-wrap align-items-center">
          <div class="ml-auto">
            <button class="btn btn-addition mr-1" @click="$router.push(`result`)">
              List
            </button>
          </div>
        </div>
        <!--//-------------------------------------------------------------------------List 버튼 -->
      </div>
    </div>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>